module.exports = __webpack_public_path__ + "static/media/3.b6bbd28f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/3.jpg
// module id = 229
// module chunks = 0